import React from 'react'

const NotFound = () => {
  return (
    <div className='w-screen h-screen flex justify-center items-center text-2xl font-bold underline'>404 not found :/</div>
  )
}

export default NotFound